export default __webpack_public_path__ + "static/media/05_liska_Saj-min.1b86ef31.jpg";